<template>
    <div class="row mx-auto my-2 py-4">
        <div class="col-md-3 p-0 mx-auto">
          <qr-maker></qr-maker>
        </div>
        <div class="col-md mx-auto p-3">
            <div class="row mx-auto">
                <v-expansion-panels class="px-1">
                    <v-expansion-panel class="mb-1">
                        <v-expansion-panel-header class="text-right">
                            whatsApp
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <div class="row mx-auto">
                                <div class="col-md-3">
                                    <v-autocomplete outlined
                                                    dense
                                                    v-model="data.preCode"
                                                    :items="flags"
                                                    item-text="preCode"
                                                    item-value="preCode"
                                                    label="پیش شماره کشور:"
                                                    append-icon="mdi-flag">
                                        <template v-slot:item="{ props, item }">
                                            <span class="text-lg bg-white">  {{ item.emoji }}  </span> (
                                            {{ item.preCode }}) {{ item.name }}
                                        </template>
                                    </v-autocomplete>
                                </div>
                                <div class="col-md-9">
                                    <v-text-field outlined
                                                  v-model="data.number"
                                                  dense
                                                  maxLength="10"
                                                  counter="10"
                                                  placeholder="شماره موردنظر خودرا بدون 0 وارد کنید."
                                                  hint="شماره موردنظر خودرا بدون 0 وارد کنید."
                                                  label="شماره "
                                                  append-icon="mdi-phone"/>
                                </div>
                                <p class="my-2">متن پیام :</p>
                                <V8Editor class="mt-2 py-3" v-model="data.text"/>
                            </div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </div>
            <qr-generator></qr-generator>
        </div>
    </div>
</template>

<script>
import QrGenerator from "./components/qrGenerator";
import QrMaker from "./components/qrMaker";

export default {
    name: "qrWhatsApp",
    components: {QrMaker, QrGenerator},
    data() {
        return {
            flags: [
                {preCode: "98+", emoji: "🇮🇷", name: "Iran"},
                {preCode: "376+", emoji: "🇦🇩", name: "Andorra"},
                {preCode: "971+", emoji: "🇦🇪", name: "United Arab Emirates"},
                {preCode: "93+", emoji: "🇦🇫", name: "Afghanistan"},
                {preCode: "1+", emoji: "🇦🇬", name: "Antigua & Barbuda"},
                {preCode: "1+", emoji: "🇦🇮", name: "Anguilla"},
                {preCode: "355+", emoji: "🇦🇱", name: "Albania"},
                {preCode: "374+", emoji: "🇦🇲", name: "Armenia"},
                {preCode: "672+", emoji: "🇦🇶", name: "Antarctica"},
                {preCode: "54+", emoji: "🇦🇷", name: "Argentina"},
                {preCode: "1684+", emoji: "🇦🇸", name: "American Samoa"},
                {preCode: "43+", emoji: "🇦🇹", name: "Austria"},
                {preCode: "61+", emoji: "🇦🇺", name: "Australia"},
                {preCode: "297+", emoji: "🇦🇼", name: "Aruba"},
                {preCode: "994+", emoji: "🇦🇿", name: "Azerbaijan"},
                {preCode: "124+6", emoji: "🇧🇧", name: "Barbados"},
                {preCode: "880+", emoji: "🇧🇩", name: "Bangladesh"},
                {preCode: "32+", emoji: "🇧🇪", name: "Belgium"},
                {preCode: "226+", emoji: "🇧🇫", name: "Burkina Faso"},
                {preCode: "359+", emoji: "🇧🇬", name: "Bulgaria"},
                {preCode: "973+", emoji: "🇧🇭", name: "Bahrain"},
                {preCode: "257+", emoji: "🇧🇮", name: "Burundi"},
                {preCode: "1441+", emoji: "🇧🇲", name: "Bermuda"},
                {preCode: "673+", emoji: "🇧🇳", name: "Brunei"},
                {preCode: "591+", emoji: "🇧🇴", name: "Bolivia"},
                {preCode: "55+", emoji: "🇧🇷", name: "Brazil"},
                {preCode: "1242+", emoji: "🇧🇸", name: "Bahamas"},
                {preCode: "975+", emoji: "🇧🇹", name: "Bhutan"},
                {preCode: "267+", emoji: "🇧🇼", name: "Botswana"},
                {preCode: "375+", emoji: "🇧🇾", name: "Belarus"},
                {preCode: "501+", emoji: "🇧🇿", name: "Belize"},
                {preCode: "1+", emoji: "🇨🇦", name: "Canada"},
                {preCode: "41+", emoji: "🇨🇭", name: "Switzerland"},
                {preCode: "682+", emoji: "🇨🇰", name: "Cook Islands"},
                {preCode: "56+", emoji: "🇨🇱", name: "Chile"},
                {preCode: "237+", emoji: "🇨🇲", name: "Cameroon"},
                {preCode: "86+", emoji: "🇨🇳", name: "China"},
                {preCode: "57+", emoji: "🇨🇴", name: "Colombia"},
                {preCode: "506+", emoji: "🇨🇷", name: "Costa Rica"},
                {preCode: "53+", emoji: "🇨🇺", name: "Cuba"},
                {preCode: "238+", emoji: "🇨🇻", name: "Cape Verde"},
                {preCode: "357+", emoji: "🇨🇾", name: "Cyprus"},
                {preCode: "49+", emoji: "🇩🇪", name: "Germany"},
                {preCode: "246+", emoji: "🇩🇬", name: "Diego Garcia"},
                {preCode: "253+", emoji: "🇩🇯", name: "Djibouti"},
                {preCode: "45+", emoji: "🇩🇰", name: "Denmark"},
                {preCode: "1767+", emoji: "🇩🇲", name: "Dominica"},
                {preCode: "1808+", emoji: "🇩🇴", name: "Dominican Republic"},
                {preCode: "213+", emoji: "🇩🇿", name: "Algeria"},
                {preCode: "593+", emoji: "🇪🇨", name: "Ecuador"},
                {preCode: "372+", emoji: "🇪🇪", name: "Estonia"},
                {preCode: "20+", emoji: "🇪🇬", name: "Egypt"},
                {preCode: "291+", emoji: "🇪🇷", name: "Eritrea"},
                {preCode: "34+", emoji: "🇪🇸", name: "Spain"},
                {preCode: "251+", emoji: "🇪🇹", name: "Ethiopia"},
                {preCode: "358+", emoji: "🇫🇮", name: "Finland"},
                {preCode: "679+", emoji: "🇫🇯", name: "Fiji"},
                {preCode: "500+", emoji: "🇫🇰", name: "Falkland Islands"},
                {preCode: "691+", emoji: "🇫🇲", name: "Micronesia"},
                {preCode: "298+", emoji: "🇫🇴", name: "Faroe Islands"},
                {preCode: "33+", emoji: "🇫🇷", name: "France"},
                {preCode: "241+", emoji: "🇬🇦", name: "Gabon"},
                {preCode: "44+", emoji: "🇬🇧", name: "United Kingdom"},
                {preCode: "1473+", emoji: "🇬🇩", name: "Grenada"},
                {preCode: "995+", emoji: "🇬🇪", name: "Georgia"},
                {preCode: "594+", emoji: "🇬🇫", name: "French Guiana"},
                {preCode: "233+", emoji: "🇬🇭", name: "Ghana"},
                {preCode: "350+", emoji: "🇬🇮", name: "Gibraltar"},
                {preCode: "299+", emoji: "🇬🇱", name: "Greenland"},
                {preCode: "220+", emoji: "🇬🇲", name: "Gambia"},
                {preCode: "224+", emoji: "🇬🇳", name: "Guinea"},
                {preCode: "590+", emoji: "🇬🇵", name: "Guadeloupe"},
                {preCode: "240+", emoji: "🇬🇶", name: "Equatorial Guinea"},
                {preCode: "30+", emoji: "🇬🇷", name: "Greece"},
                {preCode: "502+", emoji: "🇬🇹", name: "Guatemala"},
                {preCode: "1671+", emoji: "🇬🇺", name: "Guam"},
                {preCode: "592+", emoji: "🇬🇾", name: "Guyana"},
                {preCode: "504+", emoji: "🇭🇳", name: "Honduras"},
                {preCode: "385+", emoji: "🇭🇷", name: "Croatia"},
                {preCode: "509+", emoji: "🇭🇹", name: "Haiti"},
                {preCode: "36+", emoji: "🇭🇺", name: "Hungary"},
                {preCode: "62+", emoji: "🇮🇩", name: "Indonesia"},
                {preCode: "353+", emoji: "🇮🇪", name: "Ireland"},
                {preCode: "91+", emoji: "🇮🇳", name: "India"},
                {preCode: "964+", emoji: "🇮🇶", name: "Iraq"},
                {preCode: "354+", emoji: "🇮🇸", name: "Iceland"},
                {preCode: "39+", emoji: "🇮🇹", name: "Italy"},
                {preCode: "187+6", emoji: "🇯🇲", name: "Jamaica"},
                {preCode: "962+", emoji: "🇯🇴", name: "Jordan"},
                {preCode: "81+", emoji: "🇯🇵", name: "Japan"},
                {preCode: "254+", emoji: "🇰🇪", name: "Kenya"},
                {preCode: "996+", emoji: "🇰🇬", name: "Kyrgyzstan"},
                {preCode: "855+", emoji: "🇰🇭", name: "Cambodia"},
                {preCode: "686+", emoji: "🇰🇮", name: "Kiribati"},
                {preCode: "850+", emoji: "🇰🇵", name: "North Korea"},
                {preCode: "82+", emoji: "🇰🇷", name: "South Korea"},
                {preCode: "965+", emoji: "🇰🇼", name: "Kuwait"},
                {preCode: "1345+", emoji: "🇰🇾", name: "Cayman Islands"},
                {preCode: "7+", emoji: "🇰🇿", name: "Kazakhstan"},
                {preCode: "856+", emoji: "🇱🇦", name: "Laos"},
                {preCode: "961+", emoji: "🇱🇧", name: "Lebanon"},
                {preCode: "423+", emoji: "🇱🇮", name: "Liechtenstein"},
                {preCode: "94+", emoji: "🇱🇰", name: "Sri Lanka"},
                {preCode: "231+", emoji: "🇱🇷", name: "Liberia"},
                {preCode: "266+", emoji: "🇱🇸", name: "Lesotho"},
                {preCode: "370+", emoji: "🇱🇹", name: "Lithuania"},
                {preCode: "352+", emoji: "🇱🇺", name: "Luxembourg"},
                {preCode: "371+", emoji: "🇱🇻", name: "Latvia"},
                {preCode: "218+", emoji: "🇱🇾", name: "Libya"},
                {preCode: "212+", emoji: "🇲🇦", name: "Morocco"},
                {preCode: "377+", emoji: "🇲🇨", name: "Monaco"},
                {preCode: "373+", emoji: "🇲🇩", name: "Moldova"},
                {preCode: "261+", emoji: "🇲🇬", name: "Madagascar"},
                {preCode: "692+", emoji: "🇲🇭", name: "Marshall Islands"},
                {preCode: "223+", emoji: "🇲🇱", name: "Mali"},
                {preCode: "976+", emoji: "🇲🇳", name: "Mongolia"},
                {preCode: "596+", emoji: "🇲🇶", name: "Martinique"},
                {preCode: "222+", emoji: "🇲🇷", name: "Mauritania"},
                {preCode: "1664+", emoji: "🇲🇸", name: "Montserrat"},
                {preCode: "356+", emoji: "🇲🇹", name: "Malta"},
                {preCode: "230+", emoji: "🇲🇺", name: "Mauritius"},
                {preCode: "960+", emoji: "🇲🇻", name: "Maldives"},
                {preCode: "265+", emoji: "🇲🇼", name: "Malawi"},
                {preCode: "52+", emoji: "🇲🇽", name: "Mexico"},
                {preCode: "60+", emoji: "🇲🇾", name: "Malaysia"},
                {preCode: "258+", emoji: "🇲🇿", name: "Mozambique"},
                {preCode: "264+", emoji: "🇳🇦", name: "Namibia"},
                {preCode: "687+", emoji: "🇳🇨", name: "New Caledonia"},
                {preCode: "227+", emoji: "🇳🇪", name: "Niger"},
                {preCode: "6723+", emoji: "🇳🇫", name: "Norfolk Island"},
                {preCode: "243+", emoji: "🇳🇬", name: "Nigeria"},
                {preCode: "505+", emoji: "🇳🇮", name: "Nicaragua"},
                {preCode: "31+", emoji: "🇳🇱", name: "Netherlands"},
                {preCode: "47+", emoji: "🇳🇴", name: "Norway"},
                {preCode: "977+", emoji: "🇳🇵", name: "Nepal"},
                {preCode: "674+", emoji: "🇳🇷", name: "Nauru"},
                {preCode: "368+", emoji: "🇳🇺", name: "Niue"},
                {preCode: "64+", emoji: "🇳🇿", name: "New Zealand"},
                {preCode: "968+", emoji: "🇴🇲", name: "Oman"},
                {preCode: "507+", emoji: "🇵🇦", name: "Panama"},
                {preCode: "968+", emoji: "🇵🇪", name: "Peru"},
                {preCode: "689+", emoji: "🇵🇫", name: "French Polynesia"},
                {preCode: "675+", emoji: "🇵🇬", name: "Papua New Guinea"},
                {preCode: "63+", emoji: "🇵🇭", name: "Philippines"},
                {preCode: "92+", emoji: "🇵🇰", name: "Pakistan"},
                {preCode: "48+", emoji: "🇵🇱", name: "Poland"},
                {preCode: "1787+", emoji: "🇵🇷", name: "Puerto Rico"},
                {preCode: "351+", emoji: "🇵🇹", name: "Portugal"},
                {preCode: "680+", emoji: "🇵🇼", name: "Palau"},
                {preCode: "595+", emoji: "🇵🇾", name: "Paraguay"},
                {preCode: "974+", emoji: "🇶🇦", name: "Qatar"},
                {preCode: "262+", emoji: "🇷🇪", name: "Réunion"},
                {preCode: "40+", emoji: "🇷🇴", name: "Romania"},
                {preCode: "381+", emoji: "🇷🇸", name: "Serbia"},
                {preCode: "7+", emoji: "🇷🇺", name: "Russia"},
                {preCode: "250+", emoji: "🇷🇼", name: "Rwanda"},
                {preCode: "966+", emoji: "🇸🇦", name: "Saudi Arabia"},
                {preCode: "677+", emoji: "🇸🇧", name: "Solomon Islands"},
                {preCode: "248+", emoji: "🇸🇨", name: "Seychelles"},
                {preCode: "249+", emoji: "🇸🇩", name: "Sudan"},
                {preCode: "46+", emoji: "🇸🇪", name: "Sweden"},
                {preCode: "65+", emoji: "🇸🇬", name: "Singapore"},
                {preCode: "386+", emoji: "🇸🇮", name: "Slovenia"},
                {preCode: "421+", emoji: "🇸🇰", name: "Slovakia"},
                {preCode: "232+", emoji: "🇸🇱", name: "Sierra Leone"},
                {preCode: "378+", emoji: "🇸🇲", name: "San Marino"},
                {preCode: "221+", emoji: "🇸🇳", name: "Senegal"},
                {preCode: "252+", emoji: "🇸🇴", name: "Somalia"},
                {preCode: "597+", emoji: "🇸🇷", name: "Suriname"},
                {preCode: "963+", emoji: "🇸🇾", name: "Syria"},
                {preCode: "235+", emoji: "🇹🇩", name: "Chad"},
                {preCode: "228+", emoji: "🇹🇬", name: "Togo"},
                {preCode: "66+", emoji: "🇹🇭", name: "Thailand"},
                {preCode: "992+", emoji: "🇹🇯", name: "Tajikistan"},
                {preCode: "690+", emoji: "🇹🇰", name: "Tokelau"},
                {preCode: "993+", emoji: "🇹🇲", name: "Turkmenistan"},
                {preCode: "216+", emoji: "🇹🇳", name: "Tunisia"},
                {preCode: "676+", emoji: "🇹🇴", name: "Tonga"},
                {preCode: "90+", emoji: "🇹🇷", name: "Turkey"},
                {preCode: "688+", emoji: "🇹🇻", name: "Tuvalu"},
                {preCode: "886+", emoji: "🇹🇼", name: "Taiwan"},
                {preCode: "255+", emoji: "🇹🇿", name: "Tanzania"},
                {preCode: "380+", emoji: "🇺🇦", name: "Ukraine"},
                {preCode: "256+", emoji: "🇺🇬", name: "Uganda"},
                {preCode: "1+", emoji: "🇺🇸", name: "United States"},
                {preCode: "598+", emoji: "🇺🇾", name: "Uruguay"},
                {preCode: "998+", emoji: "🇺🇿", name: "Uzbekistan"},
                {preCode: "379+", emoji: "🇻🇦", name: "Vatican City"},
                {preCode: "58+", emoji: "🇻🇪", name: "Venezuela"},
                {preCode: "84+", emoji: "🇻🇳", name: "Vietnam"},
                {preCode: "678+", emoji: "🇻🇺", name: "Vanuatu"},
                {preCode: "967+", emoji: "🇾🇪", name: "Yemen"},
                {preCode: "262+", emoji: "🇾🇹", name: "Mayotte"},
                {preCode: "27+", emoji: "🇿🇦", name: "South Africa"},
                {preCode: "260+", emoji: "🇿🇲", name: "Zambia"},
                {preCode: "263+", emoji: "🇿🇼", name: "Zimbabwe"},
            ],
            data: {
                number: '',
                preCode: '',
                text: ''
            },
        }
    },
    methods: {
        justEnglish(str) {
            const p = /^(\w|\.|\d)$/i;
            if (p.test(str.key)) {
                return str.key
            } else
                str.preventDefault();
        },
    }
}
</script>

<style scoped>

</style>